import { render, staticRenderFns } from "./CustomOrderThanks.vue?vue&type=template&id=c6bfd048&scoped=true"
import script from "./CustomOrderThanks.vue?vue&type=script&lang=js"
export * from "./CustomOrderThanks.vue?vue&type=script&lang=js"
import style0 from "./CustomOrderThanks.vue?vue&type=style&index=0&id=c6bfd048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bfd048",
  null
  
)

export default component.exports